import Cookies from "js-cookie";

export const getMaintenanceRoutes = () => {
  const raw = Cookies.get("maintenance_routes");
  try {
    return raw ? JSON.parse(raw) : [];
  } catch (err) {
    console.error("Failed to parse maintenance_routes cookie:", err);
    return [];
  }
};

export const isUnderMaintenance = (routeName) => {
  const routes = getMaintenanceRoutes();  
  return routes.includes(routeName.toLowerCase());
};
